import './Header.css'
const Header = () => {
  return (
    <div className='header-image'>
      <a href='/'>
        <img src='Sunnydaze-NHS.png'/>
      </a>
      <br/>
      <span className='header-text'>CRYSTAL BALL</span><br/>
    </div>
  )
}

export default Header